import _defineProperty from "E:/code/jinhua-step-two/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

import { Component, Vue, Prop } from "vue-property-decorator";
let ListModal = class ListModal extends Vue {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "is_show", true);

    _defineProperty(this, "base_url", process.env.VUE_APP_BASE_URL);

    _defineProperty(this, "list_data", void 0);

    _defineProperty(this, "color", void 0);
  }

  clickItem(item) {
    this.$emit("clickItem", item);
  }

};

__decorate([Prop({
  default: []
})], ListModal.prototype, "list_data", void 0);

__decorate([Prop({
  default: ''
})], ListModal.prototype, "color", void 0);

ListModal = __decorate([Component], ListModal);
export default ListModal;